// extracted by mini-css-extract-plugin
export default {"block":"ButtonForm_block__KcQ1A"};